import React from "react";
import { Addon, DiscountRow, Product } from "./OrderForm/types.ts";
import { Product as JsonLDProduct, WithContext } from "schema-dts";
import { getAdditionalProperties, getAddons, getCleanedText, getPriceElement } from "./jsonLDHelpers.ts";
import { useAppTranslation } from "../../translations/useAppTranslation.ts";


function ProductJsonLD({ product, variantId, discountRows, additionalServices }: { product: Product, variantId: string, discountRows: DiscountRow[], additionalServices: Addon[] }) {

  const { db_t, t } = useAppTranslation();

  if (!product) {
    return null;
  }

  const variants = product.variants.filter(variant => variant.is_available === 1 && variant.is_hidden === 0)
  if (variants.length === 0) {
    return null;
  }

  const productVariant = variants.find(variant => variant.contract_template_id === variantId);
  if (!productVariant) {
    return null;
  }


  const discountRow = discountRows?.find(row => row.productId === productVariant.hs_id);
  const discountPeriodSameAsContract = discountRow?.duration === parseInt(productVariant.contract_period.label.split(' kk')[0]);


  const jsonLd: WithContext<JsonLDProduct> = {
    '@context': 'https://schema.org',
    "@type": "Product",
    name: db_t(productVariant, 'name'),
    url: productVariant.product_page_link,
    description: getCleanedText(db_t(productVariant, 'ldjson_description') || db_t(productVariant, 'description')),
    image: "https://www.lumme-energia.fi/hubfs/auringonkukka%20rajattu%20900.jpg",
    sku: productVariant.contract_template_id,
    offers: [
      {
        "@type": "Offer",
        availability: "https://schema.org/InStock",
        price: discountPeriodSameAsContract ? 0 : productVariant.monthly_price,
        priceCurrency: "EUR"
      },
      {
        "@type": "Offer",
        availability: "https://schema.org/InStock",
        priceSpecification: getPriceElement(productVariant, discountRows, t),
        addOn: getAddons(productVariant, additionalServices, t),
      }],
    additionalProperty: getAdditionalProperties(productVariant, t),
    brand: {
      "@type": "Brand",
      name: "Lumme Energia"
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd, null, 2) }}
    />
  );
}

export default ProductJsonLD;